import React from 'react'
import { connect } from 'react-redux'
import {reduxForm, formValueSelector} from 'redux-form'
import validate from './validations/validate'
import asyncValidate from './validations/asyncValidate'
import DavronFormRequestType from './components/common/services'
import OfficialTranslation from './components/translation/official'
import SpecializedTranslation from './components/translation/specialized'
import Interpreting from './components/interpreting/interpreting'
import Coaching from './components/coaching/coaching'
import { CSSTransitionGroup } from 'react-transition-group'
import i18n from './translations/i18n';

const selector = formValueSelector('davron')

let DavronFormSecondPage = props => {
	const {handleSubmit, previousPage, service} = props
	let lng = props.lng;
	let isTranslation = (service === 'translation' ? true : false)
	let isOfficial = (service === 'official' ? true : false)
	let isInterpreting = (service === 'interpreting' ? true : false)
	let isCoaching = (service === 'coaching' ? true : false)
	let showError = false;
	let showHelpText = false;
	if ((props.uploadedFiles===undefined || props.uploadedFiles.length===0) && props.filesAdded===false) {
		showError = true;
	}

	if (props.uploadedFiles!==undefined && props.uploadedFiles.length>0) {
		showHelpText = true;
	}
  return (
		<div className="before-form">
			<CSSTransitionGroup
						transitionName="davron"
						transitionEnterTimeout={500}
						transitionLeaveTimeout={300}
					>
				<DavronFormRequestType 
					lng={props.lng}
					onClick={props.serviceRequestClick}
				/>
			</CSSTransitionGroup>
			<form onSubmit={handleSubmit}>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={300}
				>

					{isTranslation&&<SpecializedTranslation
						lng={props.lng}
						countries={props.countries}
						fromLang={props.fromLang}
						toLang={props.toLang}
						certifications={props.certifications}
						specialtyFields={props.specialtyFields}
						showHelpText={showHelpText}
					/>}

				</CSSTransitionGroup>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={300}
				>
					
					{isOfficial&&<OfficialTranslation
						lng={props.lng}
						countries={props.countries}
						fromLang={props.fromLang}
						toLang={props.toLang}
						documentTypes={props.documentTypes}
						requestOrigin={props.requestOrigin}
						showHelpText={showHelpText}
					/>}

				</CSSTransitionGroup>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={300}
				>

				{isInterpreting&&<Interpreting
					lng={props.lng}
					interpretingPurposes={props.interpretingPurposes}
					interpretingTypes={props.interpretingTypes}
					durations={props.durations}
					fromLang={props.fromLang}
					toLang={props.toLang}
				/>}

				</CSSTransitionGroup>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={300}
				>

				{isCoaching&&<Coaching
					lng={props.lng}
					from_lang={props.fromLang}
					number_of_hours={props.numberOfHours}
					levels={props.levels}
				/>}

				</CSSTransitionGroup>
				<div>
					<button type="button" className="btn btn-orange previous" onClick={previousPage}>{i18n.t('button.previous', {lng})}</button>
					<button type="submit" className="btn btn-orange next">{i18n.t('button.next', {lng})}</button>
					{showError&&<div className="error" style={{textAlign: "right"}}>{i18n.t('button.add_file', {lng})}</div>}
				</div>
			</form>
		</div>
  )
}

DavronFormSecondPage = connect(
  (state, props) => ({
	service: selector(state, 'service'),
	translationType: selector(state, 'translationType')
  })
)(DavronFormSecondPage)

export default reduxForm({
	form: 'davron',
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	asyncValidate,
	asyncBlurFields: ['sourceLanguage', 'targetLanguage', 'interpretingDuration', 'interpretorsNumber',
	'interpretingType', 'coachingLanguage', 'coachingLevel', 'coachingPackage'],
	validate
})(DavronFormSecondPage)


// WEBPACK FOOTER //
// ./src/DavronFormSecondPage.js